export const TOPBAR = "topbar";
export const SIDEBAR = "sidebar";
export const FOOTER = "footer";
export const LOGINPAGE = "loginpage";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const WS_CONNECT = "WS_CONNECT";
export const YAAR = "yaar";
